import styled from 'styled-components'
import { device } from '../../../../styles/GlobalVariables'

const Svg = styled.svg`
  width: 42.912px;
  height: 46.804px;

  ${device.regular} {
    width: 64.368px;
    height: 70.206px;
  }
`

/** the 13 with its glow, on the ad-block screen */
export const Logo13Icon = () => (
  <Svg
    viewBox='0 0 42.912 46.8039'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <g filter='url(#logo13-glow-yellow)'>
      <path
        d='M39.0575 3.85453L30.3309 12.5892H39.0575V3.85453Z'
        fill='#FFF760'
      />
    </g>
    <g filter='url(#logo13-glow-pink)'>
      <path
        d='M39.0572 3.85453H11.1828V12.5892H30.3306L39.0572 3.85453Z'
        fill='url(#logo13-pink)'
      />
    </g>
    <g filter='url(#logo13-glow-cyan)'>
      <path
        d='M30.3309 12.589L21.6358 21.2988C21.0433 21.8923 21.0433 22.8532 21.6358 23.4451L26.7294 28.5472L39.0575 16.1983V12.5873H30.3309V12.589Z'
        fill='#2EFBEE'
      />
    </g>
    <path
      d='M0 46.8039H8.95522V3.85513H1.87461C0.838943 3.85849 0 4.72462 0 5.79384V46.8022V46.8039Z'
      fill='#000721'
    />
    <path
      d='M29.2951 28.272C30.271 29.2678 30.8734 30.6327 30.8734 32.1373C30.8734 35.188 28.4038 37.6617 25.3583 37.6617C22.3128 37.6617 19.9195 35.2611 19.8465 32.2736H10.7199C10.7929 40.3101 17.3188 46.8021 25.3583 46.8021C33.3978 46.8021 39.9984 40.2369 39.9984 32.1373C39.9984 28.1074 38.3735 24.4583 35.7479 21.8083L29.2951 28.272Z'
      fill='#000721'
    />
    <path
      d='M39.0572 3.85513H11.1828V12.5898H30.3306L39.0572 3.85513Z'
      fill='url(#logo13-pink-top)'
    />
    <path
      d='M39.0575 3.85513L30.3309 12.5898H39.0575V3.85513Z'
      fill='url(#logo13-yellow)'
    />
    <defs>
      <filter
        id='logo13-glow-yellow'
        x='26.4763'
        y='-9.53441e-08'
        width='16.4357'
        height='16.4438'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='1.92727' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.376471 0 0 0 0.3 0'
        />
        <feBlend mode='normal' in2='BackgroundImageFix' result='glow' />
        <feBlend mode='normal' in='SourceGraphic' in2='glow' result='shape' />
      </filter>
      <filter
        id='logo13-glow-pink'
        x='7.32828'
        y='-9.53441e-08'
        width='35.5834'
        height='16.4438'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='1.92727' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.909804 0 0 0 0 0.211765 0 0 0 0 0.67451 0 0 0 0.3 0'
        />
        <feBlend mode='normal' in2='BackgroundImageFix' result='glow' />
        <feBlend mode='normal' in='SourceGraphic' in2='glow' result='shape' />
      </filter>
      <filter
        id='logo13-glow-cyan'
        x='17.3369'
        y='8.73281'
        width='25.5751'
        height='23.669'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='1.92727' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.180392 0 0 0 0 0.984314 0 0 0 0 0.933333 0 0 0 0.3 0'
        />
        <feBlend mode='normal' in2='BackgroundImageFix' result='glow' />
        <feBlend mode='normal' in='SourceGraphic' in2='glow' result='shape' />
      </filter>
      <linearGradient
        id='logo13-pink'
        x1='11.3432'
        y1='12.8022'
        x2='38.8014'
        y2='3.84084'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D51896' />
        <stop offset='1' stopColor='#FF5CC7' />
      </linearGradient>
      <linearGradient
        id='logo13-pink-top'
        x1='11.3432'
        y1='12.8028'
        x2='38.8014'
        y2='3.84144'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D51896' />
        <stop offset='1' stopColor='#FF5CC7' />
      </linearGradient>
      <linearGradient
        id='logo13-yellow'
        x1='39.1046'
        y1='8.62721'
        x2='30.4507'
        y2='12.8085'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFF760' />
        <stop offset='1' stopColor='#FFF100' />
      </linearGradient>
    </defs>
  </Svg>
)
